import React, { useEffect, useState } from "react";
import Loader from "../global/Loader";
import DataTable from "../datatable/DataTable";
import { network_operators } from "../../constants/data";
import FabButton from "../global/FabButton";
import SidePanel from "../global/SidePanel";
import { useDispatch } from "react-redux";
import { openAddSideModal, setSelectedOperatorAction } from "../../redux/Index";
import TextInput from "../global/TextInput";
import Button from "../global/Button";
import HeaderText from "../global/HeaderText";
import FullDateFormat from "../global/FullDateFormat";
import { Link } from "react-router-dom";

function OperatorsList() {
  const [isEdit, setIsEdit] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const dispatch = useDispatch();

  const headers = [
    "Logo",
    "Operator name",
    "Paybill number",
    "Commission",
    "Date created",
    "Edit",
    "Transactions",
  ];
  let tableRows = [];
  if (network_operators.length) {
    for (let i = 0; i < network_operators.length; i++) {
      tableRows.push({
        logo: (
          <img
            src={network_operators[i].logo}
            className="w-10 h-10 rounded-full"
            alt="Uimage"
          />
        ),
        operator_name: network_operators[i].operator_name,
        paybill_number: network_operators[i].paybill_number,
        commission: network_operators[i].commission,
        created_at: (
          <FullDateFormat>{network_operators[i].created_at}</FullDateFormat>
        ),
        edit: (
          <i
            className="bx bx-pencil links text-[16px] cursor-pointer"
            onClick={() => editItem(network_operators[i])}
          ></i>
        ),
        more: (
          <Link to="/network_operators/transactions">
            <i
              className="bx bx-link-external links text-[16px] cursor-pointer"
              onClick={() => setSelectedOperator(network_operators[i])}
            ></i>
          </Link>
        ),
      });
    }
  }

  useEffect(() => {
    if (isEdit && selectedItem) {
      setInputValues({
        logo: selectedItem.logo,
        operator_name: selectedItem.operator_name,
        paybill_number: selectedItem.paybill_number,
        commission: selectedItem.commission,
      });
    }
  }, [isEdit, selectedItem]);

  const editItem = (item) => {
    setIsEdit(true);
    setSelectedItem(item);
    openSidePanel();
  };

  const setSelectedOperator = (item) => {
    dispatch(setSelectedOperatorAction(item));
  };

  const [inputValues, setInputValues] = useState({
    logo: "",
    operator_name: "",
    paybill_number: "",
    commission: "",
  });
  const [isSubmit, setIsSubmit] = useState(false);

  //   handle field change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValues({ ...inputValues, [name]: value });
  };

  //submit the form
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmit(true);

    if (isSubmit) {
      console.log("submit");
    }
  };

  const displayContent = network_operators ? (
    !network_operators.length ? (
      <Loader />
    ) : (
      <DataTable headers={headers} data={tableRows} />
    )
  ) : (
    <Loader />
  );

  const openSidePanel = () => {
    dispatch(openAddSideModal());
  };

  const fabIconClick = () => {
    openSidePanel();
    setIsEdit(false);
    setInputValues({
      logo: "",
      operator_name: "",
      paybill_number: "",
      commission: "",
    });
  };

  return (
    <div>
      <FabButton onPressAction={fabIconClick} />
      {/* page title */}
      <HeaderText title="Network operators" />

      <div className="flex items-center justify-start"></div>
      {displayContent}
      {/* display sidepanel */}
      <SidePanel
        width="30%"
        title="Network operators"
        subtitle={isEdit ? "Edit operators account" : "Add an operator"}
      >
        <form className="form" onSubmit={handleSubmit} autoComplete="off">
          <TextInput
            required="required"
            label="Logo"
            name="logo"
            type="text"
            value={inputValues.logo}
            onChange={handleChange}
          />
          <TextInput
            required="required"
            label="Operator name"
            name="operator_name"
            type="text"
            value={inputValues.operator_name}
            onChange={handleChange}
          />
          <TextInput
            required="required"
            label="Paybill number"
            name="paybill_number"
            type="number"
            value={inputValues.paybill_number}
            onChange={handleChange}
          />

          <TextInput
            required="required"
            label="Commission"
            name="commission"
            type="number"
            value={inputValues.commission}
            onChange={handleChange}
          />

          <Button text={isEdit ? "Update" : "Save"} disabled={isSubmit} />
        </form>
      </SidePanel>
    </div>
  );
}

export default OperatorsList;
